import client from '@libs/HttpClient';
class TaskHistoryService {
  static listTaskHistory(request) {
    const projectId = request.project_id;
    const projectTaskId = request.project_task_id;
    const historyPage = request.historyPage;
    return client.get(`/projects/view/${projectId}/task/${projectTaskId}/history?page=${historyPage}`,request);
  }
}
export { TaskHistoryService };